/**************************************************
 * Nombre:       Locales_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/port_locales.png'
import {NEGRITA} from "../../../Constantes";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Locales_Portada = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                marginTop: -14,
                background: `linear-gradient(0deg, #000 1%, rgba(0, 0, 0, 0.00) 43.66%, rgba(0, 0, 0, 0.00) 74.72%, rgba(0, 0, 0, 0.90) 100%), url(${fondo})`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center center',
            }}
        >

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-end'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: 'white', height: sCell ? 480 : 650}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{fontFamily: NEGRITA, fontSize: sCell ? 32 : 52}}>Locales Fisicos</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mb: sCell ? 3 : 8}}>
                            <Typography sx={{fontSize: sCell ? 16 : 18, lineHeight: sCell ? 1.2 : 1.3}}>Pasión por el sabor, dedicación en cada
                                detalle, la comida debe alegrar el alma. Por eso, cada plato que servimos es una muestra
                                de nuestro compromiso con la calidad y el buen gusto. Nuestras sedes están diseñadas
                                para que te sientas cómodo, relajado y enfocado en lo más importante:
                                disfrutar.</Typography>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Locales_Portada